import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'aa-dash-card',
    templateUrl: './dash-card.component.html',
    styleUrls: [
        './dash-card.component.scss'
    ],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class DashCardComponent implements OnInit
{
    @Input() header: boolean = true;
    @Input() footer: boolean = true;
    @Input() withBorder: boolean = true;
    public klass: string;

    ngOnInit (): void
    {
        if (this.header)
        {
            if (!this.footer)
            {
                this.klass = 'without-footer';
            }
        }
        else
        {
            if (this.footer)
            {
                this.klass = 'without-header';
            }
            else
            {
                this.klass = 'body-only';
            }
        }
    }
}
